var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"home"},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"hero-section"},[_c('div',{staticClass:"title"},[_c('h1',[_vm._v("ADABIYOT GULSHANI")]),_c('p',{staticClass:"subtitle"},[_vm._v(" ADABIYOT VA SAN'AT DUNYOSI ")])]),_c('HeroSection')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }